const TYPE_LABELS = {
  CAMPANHA: "Campanha",
  BANNER: "Banner",
  LOOKBOOK: "Lookbook",
  VIDEO: "Vídeo",
  MATERIAL_PDF: "Material PDF",
  INSTITUCIONAL: "Institucional",
  VM_MERCHANDISING: "VM / Merchandising",
};

export function getTypeLabel(tipo) {
  return TYPE_LABELS[tipo] || tipo;
}

export function formatPeriodo(dataInicio, dataFim) {
  const format = (date) => {
    if (!date) return "";
    const [y, m, day] = date.split("-");
    return `${day}/${m}/${y}`;
  };
  return `${format(dataInicio)} — ${format(dataFim)}`;
}

export function isContentActive(item) {
  if (item.status !== "PUBLICADO") return false;

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  if (!item.dataFim) return true;

  const [y, m, d] = item.dataFim.split("-");
  const fim = new Date(Number(y), Number(m) - 1, Number(d));
  return fim >= today;
}

export function matchesDestaqueTab(tipo, tabKey) {
  if (tabKey === "MATERIAL") {
    return ["MATERIAL_PDF", "INSTITUCIONAL", "VM_MERCHANDISING"].includes(tipo);
  }
  if (tabKey === "VIDEO") return tipo === "VIDEO";
  return tipo === tabKey;
}

export function filterMarketingContents(contents, search, filters) {
  const term = search.trim().toLowerCase();

  const filtered = contents.filter((item) => {
    if (filters.apenasAtivos && !isContentActive(item)) return false;

    if (term) {
      const matchesSearch =
        item.titulo.toLowerCase().includes(term) ||
        item.categoria.toLowerCase().includes(term) ||
        item.campanha?.toLowerCase().includes(term) ||
        item.tags?.some((tag) => tag.toLowerCase().includes(term));

      if (!matchesSearch) return false;
    }

    if (filters.tipos.length && !filters.tipos.includes(item.tipo)) return false;
    if (filters.categorias.length && !filters.categorias.includes(item.categoria)) return false;
    if (filters.campanhas.length && !filters.campanhas.includes(item.campanha)) return false;

    return true;
  });

  const sorted = [...filtered];

  if (filters.ordenacao === "downloads") {
    sorted.sort((a, b) => b.downloads - a.downloads);
  } else {
    sorted.sort((a, b) => new Date(b.dataAtualizacao) - new Date(a.dataAtualizacao));
  }

  return sorted;
}

export function getUniqueFieldValues(contents, field) {
  return [...new Set(contents.map((item) => item[field]))].sort();
}
